import dayjs from "dayjs";
import { Checkpoint } from "../models/checkpoint";

const ProjectTask = {
  /**
   * Получить текстовую метку по наличию родительской задачи.
   * @param {Number|null} parentId 
   * @returns 
   */
  getTypeLabel(parentId) {
    return null === parentId ? 'задачу' : 'подзадачу';
  },

  /**
   * Преобразовать данные о задаче, пришедших из API, к объекту формы.
   * @param {Object} type 
   * @returns
   */
  toForm(task) {
    if (undefined === task) {
      return {
        id: null,
        userId: null,
        projectTaskTargetId: null,
        projectTaskRoleId: null,
        description: '',
        checkpoints: [
          Checkpoint.generate(),
        ],
      };
    }

    return {
      id: task.id,
      projectId: task.projectId,
      parentId: task.parentId,
      userId: task.userId,
      projectTaskTargetId: task.projectTaskTargetId,
      projectTaskRoleId: task.projectTaskRoleId,
      description: task.name,
      checkpoints: task.checkpoints.map((checkpoint) => ({
        id: checkpoint.id,
        result: checkpoint.description,
        date: null === checkpoint.date ? null : dayjs(checkpoint.date),
        noMatter: null === checkpoint.date,
      })),
    };
  },

  /**
   * Преобразовать данные о задаче, пришедших из формы, к формату API.
   * @param {Object} type 
   * @returns
   */
  fromForm(task) {
    return {
      projectId: task.projectId,
      parentId: task.parentId,
      userId: task.userId,
      projectTaskRoleId: task.projectTaskRoleId,
      description: task.description,
    };
  },
};

export { ProjectTask };